"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendQueryParams = exports.mapGetAccountAddress = exports.mapGetInvoicesResponse = exports.mapBillingAccountInfoResponse = void 0;
const mapBillingAccountInfoResponse = ({ billing_city: billingCity, billing_country: billingCountry, billing_state: billingState, billing_street: billingStreet, billing_postal_code: billingPostalCode, }) => ({
    billingCity,
    billingCountry,
    billingState,
    billingStreet,
    billingPostalCode,
});
exports.mapBillingAccountInfoResponse = mapBillingAccountInfoResponse;
const mapPaymentsResponse = (_a) => {
    var { is_active: isActive, last_payment_status: lastPaymentStatus, payment_date: paymentDate, payment_method_id: paymentMethodId } = _a, otherValues = __rest(_a, ["is_active", "last_payment_status", "payment_date", "payment_method_id"]);
    return (Object.assign({ isActive,
        lastPaymentStatus,
        paymentDate,
        paymentMethodId }, otherValues));
};
const mapInvoiceResponse = (_a) => {
    var { bill_to_info, content_document_id: contentDocumentId, currency_iso_code: currencyISOCode, due_date: dueDate, issue_date: issueDate, invoice_status: invoiceStatus, payments, payment_status: paymentStatus, tax_amount: taxAmount, sub_total: subTotal } = _a, otherValues = __rest(_a, ["bill_to_info", "content_document_id", "currency_iso_code", "due_date", "issue_date", "invoice_status", "payments", "payment_status", "tax_amount", "sub_total"]);
    return (Object.assign({ billToInfo: (0, exports.mapBillingAccountInfoResponse)(bill_to_info), currencyISOCode,
        contentDocumentId,
        dueDate,
        issueDate,
        invoiceStatus, payments: payments === null || payments === void 0 ? void 0 : payments.map((payment) => mapPaymentsResponse(payment)), paymentStatus,
        subTotal,
        taxAmount }, otherValues));
};
const mapContactResponse = (_a) => {
    var { first_name: firstName, last_name: lastName, postal_code: postalCode, street_address: streetAddress } = _a, otherValues = __rest(_a, ["first_name", "last_name", "postal_code", "street_address"]);
    return (Object.assign({ firstName,
        lastName,
        postalCode,
        streetAddress }, otherValues));
};
const mapGetInvoicesResponse = (_a) => {
    var { response: { first_name: firstName, last_name: lastName, invoices, payment_status: paymentStatus, } } = _a, otherValues = __rest(_a, ["response"]);
    return (Object.assign({ response: {
            firstName,
            lastName,
            invoices: invoices
                ? invoices === null || invoices === void 0 ? void 0 : invoices.map((invoice) => mapInvoiceResponse(invoice))
                : [],
            paymentStatus,
        } }, otherValues));
};
exports.mapGetInvoicesResponse = mapGetInvoicesResponse;
const mapGetAccountAddress = (_a) => {
    var _b = _a.response, { bill_to_contact, billing_city: billingCity, billing_country: billingCountry, billing_state: billingState, billing_street: billingStreet, billing_postal_code: billingPostalCode, dashboard_email: dashboardEmail, is_email_delivery_on: isEmailDeliveryOn, primary_contact, shipping_city: shippingCity, shipping_country: shippingCountry, shipping_postal_code: shippingPostalCode, shipping_street: shippingStreet, shipping_state: shippingState } = _b, otherAddressValues = __rest(_b, ["bill_to_contact", "billing_city", "billing_country", "billing_state", "billing_street", "billing_postal_code", "dashboard_email", "is_email_delivery_on", "primary_contact", "shipping_city", "shipping_country", "shipping_postal_code", "shipping_street", "shipping_state"]), otherValues = __rest(_a, ["response"]);
    return (Object.assign({ response: Object.assign({ billToContact: mapContactResponse(bill_to_contact), billingCity,
            billingCountry,
            billingState,
            billingStreet,
            billingPostalCode,
            dashboardEmail,
            isEmailDeliveryOn, primaryContact: mapContactResponse(primary_contact), shippingCity,
            shippingCountry,
            shippingStreet,
            shippingState,
            shippingPostalCode }, otherAddressValues) }, otherValues));
};
exports.mapGetAccountAddress = mapGetAccountAddress;
const appendQueryParams = (url, params) => {
    // Remove undefined values.
    const paramsFiltered = {};
    for (const key in params) {
        if (params[key] !== undefined) {
            paramsFiltered[key] = params[key];
        }
    }
    const queryParams = new URLSearchParams(paramsFiltered).toString();
    if (queryParams)
        url = `${url}?${queryParams}`;
    return url;
};
exports.appendQueryParams = appendQueryParams;
